import React from 'react';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <div className="form-contact-page">
        <h1 className="contact-title">📬 Reach Out to Us</h1>
        <form
          id="contactForm"
          action="https://formsubmit.co/084271bf7aab736c23e10cf17a9dbcb9"
          method="POST">
          <div className="form-group-row">
            <input
              type="text"
              className="form-control"
              placeholder="First Name"
              name="name"
              required
            />
            <input
              type="text"
              className="form-control"
              placeholder="Last Name"
              name="last_name"
              required
            />
          </div>

          <label>Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="Email address"
            name="email"
            required
          />

          <label>Preference</label>
          <select className="form-select" name="preference" required>
            <option defaultValue>Upcoming Event</option>
            <option value="Location">Location</option>
            <option value="SSN">SSN</option>
            <option value="Ride to/from New Orleans">Ride to/from New Orleans</option>
            <option value="Shopping">Shopping</option>
            <option value="Driver Licence">Driver Licence</option>
            <option value="Flight Information">Flight Information</option>
            <option value="Career Counselling">Career Counselling</option>
            <option value="Other">Other</option>
          </select>

          <label>Message</label>
          <textarea
            className="form-control"
            rows="4"
            placeholder="Type your message here"
            name="message"
            required></textarea>

          <button className="btn-submit" type="submit">
            Send
          </button>
        </form>
      </div>

      <div className="contact-info">
        <h2>📨 Contact Details</h2>
        <div className="info-block">
          <p className="contact-label">NSAS Official Email</p>
          <p>nsas.slu@gmail.com</p>
        </div>
        <div className="info-block">
          <p className="contact-label">President Email</p>
          <p>mahesh.pandit@selu.edu</p>
        </div>

        <h2>📱 Connect With Us</h2>
        <div className="social-icons">
          <a
            href="https://www.facebook.com/Slunsas/"
            target="_blank"
            rel="noreferrer"
            title="Facebook">
            <FaFacebook className="social-icon facebook" size={28} />
          </a>
          <a
            href="https://www.instagram.com/nsas.slu/"
            target="_blank"
            rel="noreferrer"
            title="Instagram">
            <FaInstagram className="social-icon instagram" size={28} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
